import { CATEGORY_CARDS } from '@/mocks/trending';

const BUBBLE = [
  'bg-accent-100 text-accent-700',
  'bg-primary-100 text-primary-600',
  'bg-secondary-100 text-secondary-800',
  'bg-accent-100 text-accent-700',
  'bg-primary-100 text-primary-600',
];

export default function CategoryGrid() {
  return (
    <section id="category" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <div className="mx-auto mb-2 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-semibold text-secondary-800 border border-secondary-200">
            <i className="ri-menu-2-line" aria-hidden="true"></i>瓜田分类
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            挑一块<b className="text-primary-500">瓜田</b>钻进去
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm md:text-base text-foreground-600">
            娱乐、社会、体育、财经、科技，每个分类都有自己的热度曲线与话题热度值，想看哪块都有得吃。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-9 lg:grid-cols-5">
          {CATEGORY_CARDS.map((c, i) => (
            <a
              key={c.key}
              href="#hot"
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 transition hover:-translate-y-0.5 hover:border-primary-200"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${BUBBLE[i % BUBBLE.length]}`}>
                <i className={c.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
              <div className="mt-3 flex items-center justify-between">
                <span className="whitespace-nowrap rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">
                  {c.follow}
                </span>
                <span className="inline-flex items-center gap-0.5 text-xs font-medium text-primary-600 opacity-0 transition group-hover:opacity-100">
                  去看看
                  <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}